































import { mapGetters } from 'vuex'
import { PropType } from 'vue'
import ToolTip from './ToolTip.vue'
import TextInput from './TextInput.vue'
import { InputOptions } from '@typesCustom/index'

export default TextInput.extend({
  components: {
    ToolTip,
  },
  props: {
    parent: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    default: {
      type: Number,
      default: 0,
    },
    options: {
      type: Object as PropType<InputOptions>,
      required: true,
    },
  },
  computed: mapGetters(['uiText']),
  data() {
    return {
      value: 0,
      step: this.options.step ? this.options.step : 1,
    }
  },
  methods: {
    decrease() {
      if (!this.options.min || this.value > this.options.min) {
        this.value = this.value - this.step
      }
      this.$store.dispatch('saveAnswer', { id: this.id, value: this.value })
      this.$emit('change', { id: this.id, value: this.value })
    },
    increase() {
      if (!this.options.max || this.value < this.options.max) {
        this.value = this.value + this.step
      }
      this.$store.dispatch('saveAnswer', { id: this.id, value: this.value })
      this.$emit('change', { id: this.id, value: this.value })
    },
  },
})
